export default {
  mutateTestList(state, list) {
    state.testList = list;
  },
};
